import React, { useEffect, useState } from 'react'
import { connect, useSelector } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Alert, Button, Col, Row, Label, FormGroup, Input, FormFeedback, Collapse } from 'reactstrap'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import Select from 'react-select'
import { useLocation } from 'react-router-dom'
import { STYLES_REACT_SELECT_NEW_WITH_INSET_SHADOW, FACEBOOK_TAGS, MARKETING } from '../../../constants'
import { I18n } from 'react-redux-i18n'

import { marketingAct } from '../../../redux/actions'
import ValidatorTemplate from './ValidatorTemplate'
import PhoneViewer from 'components/PhoneViewer'
import ModalCopyTemplate from './ModalCopyTemplate'
import { allowTemplate, detectUrlINText } from 'utils/helpers'
import TextEditor2 from 'components/Form/TextEditor/TextEditor2'
import FormWhatsappCloudApi from './FormWhatsappCloudApi'
import Nixi1Spinner from 'components/Nixi1Spinner'
import ModalVirusAttachments from 'components/common/ModalVirusAttachments'
import { verifyFileVirus } from 'utils/FileUtils'
const _ = require('lodash')

const FormEdit = ({ currentTemplate, setFormEdit, template, updateTemplate, company, variables, templates }) => {
  const { pathname } = useLocation()
  const isChat = pathname === '/dashboard/conversations/templates'

  const [genericError, setGenericError] = useState('')
  const [textPreview, setTextPreview] = useState({})
  const currentCompany = useSelector((store) => store.companies)
  const [contentToClipboard, setContentToClipboard] = useState('')
  const providersValues = Object.values(MARKETING.providers)
  const validation = providersValues.find((v) => v.channels.includes(currentTemplate)).validation
  const [isOpenModalCopy, setIsOpenModalCopy] = useState(false)
  const [isOpenAlert, setIsOpenAlert] = useState(true)
  const [allowToSave, setAllowToSave] = useState(currentTemplate === 'facebook' ? false : true)
  const [contentHtml, setContentHml] = useState(template['contentHtml'] || template['content'])
  const acceptTypes = providersValues.find((v) => v.channels.includes(currentTemplate)).acceptTypes
  const toolbar = providersValues.find((v) => v.channels.includes(currentTemplate)).toolbar
  const channels = MARKETING.channels

  const alertMessage = currentTemplate === channels.whatsapp ? (
    <p dangerouslySetInnerHTML={{ __html: I18n.t('templates_copy_disclaimer_whatsapp2') }}/>
  ) : null

  useEffect(() => {
    setTextPreview({ ...template })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [template])

  useEffect(() => {
    if (currentTemplate === 'whatsapp') getContentToClipboardTemp(textPreview.content, textPreview.buttons, textPreview.attachments)
    if (currentTemplate !== 'whatsapp_whatsapp')
      setAllowToSave(allowTemplate(textPreview, currentTemplate, isChat))

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [textPreview])

  const handleVariableOnChange = (values, variablesName) => ({ value }) => {
    const variableToReplace = _.find(values.variables, el => {return el.name === variablesName['input']})
    if (variableToReplace) {
      values.variables.forEach(it => {
        if (it.name === variablesName['input']) {
          it.field = value
        }
      })
    }
    else {
      values.variables.push({ name: variablesName.input, field: value })
    }
    setTextPreview({ ...values })
  }

  const getSelectVariableValueByIndex = (varOptions, template, index) => {
    if (!varOptions || !varOptions.length) return

    const v = varOptions.find((v) => (template.variables[index] ? v.value === template.variables[index].field : false))

    if (!v) return

    return {
      value: template.variables[index].field,
      label: v.label,
    }
  }

  const handleOnSubmit = async (template, { setSubmitting, setFieldError }) => {
    if (currentTemplate === 'whatsapp') {
      setIsOpenModalCopy(true)
      setSubmitting(false)
      return
    }

    if (templates[currentTemplate].find(el => _.lowerCase(el.name) === _.lowerCase(template.name) && el._id !== template._id)) {
      setFieldError('name', I18n.t('templates_duplicate_name'))
      setSubmitting(false)
      return false
    }

    const newUrls = await detectUrlINText(template.contentHtml)

    if (newUrls) {
      let contentHtml = textPreview.contentHtml
      let content = textPreview.content
      let toClipboard = contentToClipboard
      newUrls.forEach((it) => {
        content = _.replace(content, it.urlLong, it.url)
        contentHtml = _.replace(contentHtml, it.urlLong, it.url)
        toClipboard = _.replace(toClipboard, it.urlLong, it.url)
      })
      template.content = content
      template.contentHtml = contentHtml
      setTextPreview({ ...textPreview, contentHtml, content })
      setContentToClipboard(toClipboard)
      setContentHml(contentHtml)
    }

    updateTemplate(template._id, template, isChat)
      .then((result) => {
        const { existVirus, attachmentsVirus } = verifyFileVirus({ data: result || {}, isOutbound: true })
        if(existVirus) {
          setTextPreview({
            ...textPreview,
            attachments: attachmentsVirus
          })
          throw result
        }
        setFormEdit({ isOpen: false, _id: template._id })
      })
      .catch((error) => (error.field ? setFieldError(error.field, I18n.t(error.type)) : setGenericError('generic_error')))
      .finally(() => setSubmitting(false))
  }

  const facebookTagsOptions = FACEBOOK_TAGS.tags.map((elem) => {
    elem.label = I18n.t(elem.label)

    return elem
  })

  const varsOptions = (variables || [])
    .map((elem) => ({
      value: elem.value,
      label: I18n.t(elem.label),
    }))
    .concat(isChat ? { value: '', label: I18n.t('dashboard_free-text') } : [])

  const getContentToClipboardTemp = (text, buttons, files) => {
    let _buttons = null
    let attachment = null
    let value = text
    if (buttons) {
      buttons.forEach((it, index) => {
        _buttons = `${index === 0 ? '' : '\n\n'}*${it.label}*\n${it.content}`
      })
      if (_buttons) value = `${value}${'\n\n' + _buttons}`
    }
    if (files) {
      files.forEach((it, index) => {
        attachment = `${index === 0 ? '' : '\n'}${it.url}`
      })
      if (attachment) value = `${value}${'\n\n' + attachment}`
    }
    return value
  }

  const getLimit = (values) => {
    let buttons = values.buttons ? values.buttons.length :  0
    let attachments = values.attachments ? values.attachments.length :  0
    let data =
      currentTemplate === channels.telegram && attachments > 0 ? validation.content.limitWithFiles
        : currentTemplate === channels.facebook && buttons > 0 && attachments === 0 ? validation.content.limitWithButtons
          : currentTemplate === channels.facebook && buttons > 0 && attachments > 0 ? validation.content.limitWithImageAndButtons
            : currentTemplate === channels.facebook && attachments > 0 ? validation.content.limitWithImageAndButtons
              : validation.content.limit

    return data
  }

  return (
    <>
      {currentTemplate === 'whatsapp_whatsapp' ?
        <FormWhatsappCloudApi template={template} setForm={setFormEdit} channel={currentTemplate} company={currentCompany} isChat={isChat} acceptTypes={acceptTypes} /> :
        <>
          <Formik
            key={'formEdit'}
            initialValues={Object.assign({}, { ...template, variablesTemp: template.variables || {}, channel: currentTemplate })}
            validate={e => ValidatorTemplate(e, allowToSave)}
            onSubmit={handleOnSubmit}
          >
            {({ isSubmitting, values, setFieldValue, errors, handleBlur }) => (
              <Form noValidate>
                <Row className='template-form-content'>
                  {alertMessage && (
                    <Row style={{ width: '100%' }}>
                      <Collapse isOpen={isOpenAlert} style={{ width: '100%' }}>
                        <Row className='alert-message'>
                          <Col sm={1} className={'img'}>
                            <img src='./img/icons/icon-warning.svg' alt={'alert'} width={'26px'} height={'22px'} />
                          </Col>
                          <Col sm={10} className={'text'}>
                            {alertMessage}
                          </Col>
                          <Col sm={1} className={'icon'}>
                            <li className='fa fa-times' onClick={() => setIsOpenAlert(!isOpenAlert)} />
                          </Col>
                        </Row>
                      </Collapse>
                    </Row>
                  )}
                  <Row>
                    <Col xs={12}>
                      {genericError && (
                        <Alert color='danger' isOpen={!!genericError} toggle={() => setGenericError('')}>
                          {I18n.t(genericError)}
                        </Alert>
                      )}
                    </Col>
                  </Row>
                  <Col sm={12} xs={12} xl={7} className='mb-4 mt-2'>
                    <Row>
                      <Col>
                        <FormGroup>
                          <Label for='name' className='required'>
                            {I18n.t('template_name')}
                          </Label>
                          <Field className='form-control' type='text' name='name' id='name' />
                          <small className='form-text text-muted'>{I18n.t('template_name_hint')}</small>
                          <ErrorMessage name='name' component='small' className='text-danger' />
                        </FormGroup>
                      </Col>
                    </Row>
                    {currentTemplate === 'chatmail' ? (
                      <Row>
                        <Col>
                          <FormGroup>
                            <Label for='subject' className='required'>
                              {I18n.t('template_subject')}
                            </Label>
                            <input
                              className='form-control'
                              type='text'
                              name='subject'
                              id='subject'
                              value={values.subject}
                              onChange={event => {
                                setTextPreview(prevState => ({ ...prevState, subject: event.target.value }))
                                setFieldValue('subject', event.target.value)
                              }}
                              onBlur={handleBlur}
                            />
                            <small className='form-text text-muted'>{I18n.t('template_subject_hint')}</small>
                            <ErrorMessage name='subject' component='small' className='text-danger' />
                          </FormGroup>
                        </Col>
                      </Row>
                    ) : null}
                    {isChat && ['facebook', 'instagram'].includes(currentTemplate) ? (
                      <Row>
                        <Col>
                          <FormGroup>
                            <Label for='relatedTag' className='required'>
                              {I18n.t('facebook_tag_select')}
                            </Label>
                            <Select
                              id='facebook-relatedTag'
                              name='relatedTag'
                              placeholder={I18n.t('facebook_tag_select')}
                              onChange={({ value }) => {
                                setFieldValue('relatedTag', value)
                              }}
                              value={values.relatedTag ? facebookTagsOptions.find((elem) => elem.value === values.relatedTag) : null}
                              options={facebookTagsOptions}
                              styles={STYLES_REACT_SELECT_NEW_WITH_INSET_SHADOW}
                            />
                            <Input hidden invalid={!!errors.relatedTag} />
                            <FormFeedback>{errors.relatedTag}</FormFeedback>
                          </FormGroup>
                        </Col>
                      </Row>
                    ) : null}

                    <Row>
                      <Col>
                        <FormGroup>
                          <Label for='content' className='required'>
                            {I18n.t('template_content')}
                          </Label>
                          <TextEditor2
                            id='content'
                            cols={5}
                            rows={7}
                            value={contentHtml}
                            company={currentCompany}
                            attachments={textPreview?.attachments || []}
                            buttons={values.buttons}
                            channel={currentTemplate}
                            variables={((currentTemplate === 'facebook' && isChat) || currentTemplate !== 'facebook') ? variables : []}
                            parent={isChat ? 'chat' : 'campaign'}
                            limit={getLimit(values)}
                            acceptTypes={isChat ? acceptTypes.chat : acceptTypes.marketing}
                            toolbar={currentTemplate === 'sms' ? toolbar.sms : currentTemplate === 'whatsapp' ? toolbar.whatsapp : toolbar}
                            options={["buttons", "emojis", "attachments"]}
                            onChange={(e) => {
                              values.content = e.value
                              values.contentHtml = e.valueHtml
                              values.buttons = e.buttons || []
                              values.attachments = e.attachments || []
                              values.allowToSave = e.counterOverflow
                              values.variablesEditor = e.variables
                              values.isTemplate = e.isTemplate
                              let vars = []
                              if (e.variables) {
                                e.variables.forEach(it => {
                                  const value = values.variables.find(el => el.name === `{{${it[0]}}}`)
                                  value && vars.push(value)
                                })
                              }
                              values.variables = vars
                              setTextPreview({ ...values })
                              setContentToClipboard(e.toClipboard)
                            }}
                            dropZoneFilesHeight={183}
                            isTemplateValue={currentTemplate !== 'whatsapp' ? values.isTemplate : true}
                            isTemplateCheck
                            maxHeight={null}
                          />
                          <ErrorMessage name='content' component='small' className='text-danger' />
                        </FormGroup>
                      </Col>
                    </Row>

                    {((currentTemplate === 'facebook' && isChat) || currentTemplate !== 'facebook') &&
                  values &&
                  values.content &&
                  values.variablesEditor &&
                  (values.variablesEditor || []).length > 0 && (
                      <Row>
                        <Col>
                          <FormGroup>
                            <Label for='code'>{I18n.t('dashboard_variables')}</Label>
                            <ul className='variables'>
                              {(values.variablesEditor || []).map((variablesName, index) => (
                                <li key={index}>
                                  <Row>
                                    <Col>
                                      <div className='code-wrapper w-20 float-left'>
                                        <code>{`{{${variablesName}}}`}</code>:
                                      </div>
                                      <div className='w-80 float-right'>
                                        <Select
                                          id={`variable--${index}`}
                                          name={`variable--${index}`}
                                          onChange={handleVariableOnChange(values, variablesName)}
                                          options={varsOptions}
                                          styles={STYLES_REACT_SELECT_NEW_WITH_INSET_SHADOW}
                                          defaultValue={getSelectVariableValueByIndex(varsOptions, template, index)}
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                </li>
                              ))}
                            </ul>
                            <ErrorMessage name='variables' component='small' className='text-danger' />
                          </FormGroup>
                        </Col>
                      </Row>
                    )}

                    <Row>
                      <Col>
                        <Button type='submit' color='btn btn-primary' disabled={values.allowToSave || !allowToSave}>
                          {isSubmitting
                            ? <Nixi1Spinner width='1rem' height='1rem' />
                            : currentTemplate === 'whatsapp'
                              ? I18n.t('dashboard_template-code')
                              : I18n.t('dashboard_save')
                          }
                        </Button>
                        <Button color='btn btn-secondary ml-2' onClick={() => setFormEdit({ isOpen: false })}>
                          {I18n.t('dashboard_cancel')}
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                  <PhoneViewer variables={variables} channel={currentTemplate} company={company} textPreview={textPreview} origin='marketing' />
                </Row>
              </Form>
            )}
          </Formik>
          <ModalCopyTemplate isOpenModal={isOpenModalCopy} setIsOpenModal={setIsOpenModalCopy} textToCopy={contentToClipboard} />
          {
            textPreview && textPreview.attachments && textPreview?.attachments.length
              ? <ModalVirusAttachments attachments={textPreview?.attachments || []} />
              : null
          }
        </>
      }
    </>
  )
}

const mapStateToProps = (state) => ({
  company: state.marketing.templates.company,
  variables: state.marketing.templates.variables,
  templates: state.marketing.templates,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateTemplate: marketingAct.updateTemplate,
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(FormEdit)
